


































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import CancelledReason from '@/models/Shared/CancelledReason';
import { BookingDetailsModule } from '@/store/modules/bookingDetails';
import CancelBookingRequest from '@/models/Bookings/CancelBookingRequest';
import PageNames from '@/router/PageNames';

@Component({
    name: 'BookingCancel'
})
export default class BookingCancel extends GiganautVueDialog {
 
  cancelledReason: CancelledReason = CancelledReason.CANCELLED_REASON_REQUIREMENTS_CHANGED;
  cancelledText = '';
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.cancelledText = '';
      this.cancelledReason = CancelledReason.CANCELLED_REASON_REQUIREMENTS_CHANGED;
    }
  }

  get cancelledReasons() {
    return ListUtils.cancelledReasonsForBooker();
  }

  get cancellationDisabled () {
    return this.cancelledText !== 'CANCEL'
  }


  async confirm() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    
    const bookingId = BookingDetailsModule.currentBooking.id;
    const request = new CancelBookingRequest()
    request.updatedAt = BookingDetailsModule.currentBooking.updatedAt;
    request.cancelledReason = this.cancelledReason;
    
    await BookingDetailsModule.cancelBooking(request)
    if (BookingDetailsModule.cancelSuccessful) {
      this.$router.go(0)
    }
    this.dialog = false;
  }
}
